import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';

export type AllowedValueEntry = Readonly<{
  frontend_value: string;
  channel_value_id: string | null;
}>;

export type GlobalCommonalityAllowedValuesData = Readonly<{
  global_set_id: number;
  commonality_key: string;
  values: AllowedValueEntry[];
  total: number;
  truncated: boolean;
  max_values: number;
}>;

type GlobalCommonalityAllowedValuesResponse = Readonly<{
  data: GlobalCommonalityAllowedValuesData;
}>;

export async function getGlobalCommonalityAllowedValues(
  scope: RequestScope,
  args: {
    globalSetId: number;
    commonalityKey: string;
    signal?: AbortSignal;
  },
  options: ReadRequestOptions
): Promise<ChannelApiResponse<GlobalCommonalityAllowedValuesData>> {
  try {
    const res = await scopedChannelApi(scope).get<GlobalCommonalityAllowedValuesResponse>('atts/commonality/global/allowed-values', {
      ...options,
      headers: buildAsturHeaders(),
      params: {
        global_set_id: args.globalSetId,
        commonality_key: args.commonalityKey,
      },
      signal: args.signal ?? options.signal,
    });

    if (!res.data?.data) {
      throw new Error('Invalid allowed values response');
    }

    return {
      data: res.data.data,
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
